import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { CMovementOrderTableRow, CancelMovingOrder, MovementOrderDetails, MovementOrderProcessingStatus, MovementOrderSelection, ProcessingStatusChange, ServiceTruckOption, TruckGroup } from './movement-orders.model';

@Injectable({
  providedIn: 'root'
})
export class MovementOrdersService {

  truckGroups = new Array<TruckGroup>();

  constructor(private httpService: HttpService) {
    this.truckGroups.push(new TruckGroup({ id: 1, name: 'Truck Gruppe 1' }));
    this.truckGroups.push(new TruckGroup({ id: 2, name: 'Truck Gruppe 2' }));
  }


  public getTruckGroups(): Observable<Array<TruckGroup>> {
    return this.httpService.postWithContext<Array<TruckGroup>>(environment.movementOrderEndpoint + '/truck-groups', {})
      .pipe(
        map(
          options => options.map(o => new TruckGroup(o))
        )
      );
  }

  public loadServiceTruckOptions(): Observable<Array<ServiceTruckOption>> {
    return this.httpService.postWithContext<Array<ServiceTruckOption>>(environment.movementOrderEndpoint + '/serice-truck-options', {})
      .pipe(
        map(
          options => options.map(o => new ServiceTruckOption(o))
        )
      );
  }

  public loadMovementOrderTableRowsForTruckGroup(serviceTruckId: number, truckGroupId: number): Observable<Array<CMovementOrderTableRow>> {
    const selection: MovementOrderSelection = {
      serviceTruckId,
      truckGroupId
    };

    return this.httpService.postWithContext<Array<CMovementOrderTableRow>>(
      environment.movementOrderEndpoint + '/table-rows',
      selection
    ).pipe(
      map(
        rows => rows.map(row => new CMovementOrderTableRow(row))
      )
    );
  }

  public loadMovementOrderDetails(movementOrderId: number): Observable<MovementOrderDetails> {
    return this.httpService.postWithContext<MovementOrderDetails>(environment.movementOrderEndpoint + '/details',
      movementOrderId
    ).pipe(
      map(
        details => new MovementOrderDetails(details)
      )
    );
  }

  public handleStatusChange(request: ProcessingStatusChange): Observable<ServiceResponse> {

    return this.httpService.postWithContext<ServiceResponse>(environment.movementOrderEndpoint + '/status-change', request)
      .pipe(
        map(r => new ServiceResponse(r))
      );
  }

  public handleStatusChangeReverse(movementOrderId: number, processingStatus: MovementOrderProcessingStatus): Observable<ServiceResponse> {

    const request: ProcessingStatusChange = {
      movementOrderId,
      processingStatus,
      serviceTruckId: null,
      vehicleId: null,
      targetStationId: null,
      reroutingTargetStationId: null
    };

    return this.httpService.postWithContext<ServiceResponse>(environment.movementOrderEndpoint + '/status-change-reverse', request)
      .pipe(
        map(r => new ServiceResponse(r))
      );
  }

  public cancelMovingOrder(movementOrderId: number): Observable<ServiceResponse> {
    const request: CancelMovingOrder = {movementOrderId};

      return this.httpService.postWithContext<ServiceResponse>(environment.movementOrderEndpoint + '/cancel', request)
      .pipe(
        map(r => new ServiceResponse(r))
      );
  }
}
